import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { useComponentSize } from '@carnica/utils/hooks';
import { useMemo, useRef } from 'react';
import { calculateVisibleItems } from "./utils";
export var useVisibleItems = function useVisibleItems(items, size, visibleCount) {
  var length = items.length;
  var parentRef = useRef(null);
  var parentSize = useComponentSize(parentRef).width;
  var visibleItems = useMemo(function () {
    if (!visibleCount) {
      return items;
    }
    if (visibleCount !== 'auto') {
      return _toConsumableArray(items).slice(0, Math.max(visibleCount - 1, 0));
    }
    return calculateVisibleItems(items, size, parentSize);
  }, [items, size, parentSize, visibleCount]);
  var hiddenCount = useMemo(function () {
    return length - visibleItems.length;
  }, [visibleItems, length]);
  return {
    visibleItems: visibleItems,
    hiddenCount: hiddenCount,
    parentRef: parentRef
  };
};